var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading"}},[_c('Spin',{class:!_vm.background?'noBack':'',attrs:{"fix":""}},[_c('div',{staticClass:"square"}),_c('p',{staticStyle:{"color":"#264653"}},[_vm._v("加载中")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }